import { render, staticRenderFns } from "./UserAutocomplete.vue?vue&type=template&id=118d6a14&"
import script from "./UserAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./UserAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports